import React, { useEffect, useState } from 'react';
import { QUERY_KEYS, SCORECARD_EMAIL_LOGS_COLUMNS, SCORECARD_REPORT } from '../../../constants';
import { popup } from '../../../utils';
import { getAllScoreCardEmailLogs } from '../../../utils/apiServices/scorecardEmailLogAPI';
import { Table } from '../Table';
import { Modal } from 'react-bootstrap';
import { useQuery } from '@tanstack/react-query';
import { usePagination } from '../../../hooks';

const EmailReportModal = ({ showModal, setShowModal, accountId }) => {
    const [reportData, setReportData] = useState(undefined);
    const pagination = usePagination(reportData?.data?.length, reportData?.count);

    const {
        data: mailReport,
        isError,
        error,
        isFetching,
        isFetched,
    } = useQuery({
        queryKey: [QUERY_KEYS.SCORECARD_EMAIL_LOGS, accountId, pagination.offset, pagination.limit],
        queryFn: async () =>
            await getAllScoreCardEmailLogs({
                offset: pagination.offset,
                limit: pagination.limit,
                account_id: accountId,
                status: 'all',
            }),
        select: (data) => ({
            data: data?.data || [],
            count: data?.count || 0,
        }),
        placeholderData: { data: [], count: 0 },
    });
    if (isError) popup('error', error?.message);

    useEffect(() => {
        if (mailReport && isFetched) {
            setReportData(mailReport);
        }
    }, [mailReport, isFetched]);

    return (
        <Modal
            show={showModal}
            onHide={() => {
                setShowModal(false);
            }}
            size='lg'
            dialogClassName='overflow-hidden'
            fullscreen='md-down'
        >
            <Modal.Header closeButton>
                <Modal.Title className='me-2'>
                    {SCORECARD_REPORT.SCORE_CARD_EMAIL_RECORDS.HEADER_HEADING}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='modal-body p-0 pt-4'>
                    {!!reportData && (
                        <Table
                            columns={SCORECARD_EMAIL_LOGS_COLUMNS}
                            data={reportData?.data}
                            pagination={pagination}
                            pageName={SCORECARD_REPORT.SCORE_CARD_EMAIL_RECORDS.HEADER_HEADING}
                            stickyColumns={['Delivery Status']}
                            isLoading={isFetching}
                        />
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default EmailReportModal;
